jQuery(document).ready(function () {
    if ($('.clients').length > 0) {
        $('.clients_carousel').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 10,
            centerPadding: '60px',
            speed: 3000,
            slidesToShow: 1,
            cssEase: 'linear',
            centerMode: true,
            variableWidth: true,
        });
    }
});

